module.exports = __webpack_public_path__ + "assets/img/discernment_gender_scene2.d1703222.png";